import validateFilePath from './validateFilePath';

const validateFileAndDownload = async (response: Blob | string, arg: { filePath: string; fileName: string }) => {
  if (!validateFilePath(arg.filePath)) {
    throw new Error('Invalid file path provided');
  }

  if (!arg.fileName || arg.fileName.trim().length === 0 || arg.fileName.length > 255) {
    throw new Error('Invalid file name provided');
  }

  let blob: Blob;

  if (typeof response === 'string') {
    // nosemgrep: javascript-ssrf-rule-node_ssrf
    const fetchResponse = await fetch(response);
    blob = await fetchResponse.blob();
  } else {
    blob = response;
  }

  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');

  link.href = url;
  link.download = arg.fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);

  return undefined;
};

export default validateFileAndDownload;
